import {
  Component,
  type ErrorInfo,
  type PropsWithChildren,
  type ReactNode,
} from "react";
import type { ClientError } from "@/types";

export interface ErrorBoundaryProps {
  fallback?: ReactNode;
}

class ErrorBoundary extends Component<PropsWithChildren<ErrorBoundaryProps>> {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const clientError: ClientError = {
      name: error.name,
      message: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack,
    };
    void fetch("/api/next/logger/report-error/", {
      method: "POST",
      body: JSON.stringify(clientError),
    });
  }

  render() {
    const { children, fallback = null } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return fallback;
    }

    return children;
  }
}

export default ErrorBoundary;
